import gql from "graphql-tag";

import { useMessageBarQuery } from "@/graphql";

import { ResendEmailConfirmation } from "./ResendEmailConfirmation";
import { SetPassword } from "./SetPassword";

export const MESSAGE_BAR_QUERY = gql`
  query MessageBarQuery {
    currentUser {
      id
      onboardingCompletedAt
      isConfirmed
      isPasswordSet
    }
  }
`;

export function MessageBar({ email }: { email: string }) {
  const { data } = useMessageBarQuery();

  if (data) {
    if (!data.currentUser.isConfirmed) {
      return <ResendEmailConfirmation email={email} />;
    }

    if (!data.currentUser.isPasswordSet) {
      return <SetPassword />;
    }
  }

  return null;
}
